// @flow
import type { LeafRuleProps } from 'types/rule-types';

import _ from 'lodash';
import React, { Component } from 'react';
import { Dropdown, Form } from 'semantic-grab-ui/src';
import {
  operatorOptions,
} from 'omega-rtc/components/rule-builder/utils';

export default class DayRule extends Component {
  props: LeafRuleProps;

  handleRuleOperatorSelect = (event: Object, dropdown: Object) => {
    const { rule } = this.props;
    let newRule = Object.assign({}, { ...rule, rhs: '' }, { operator: dropdown.value });
    if (dropdown.value === 'bt') {
      newRule = Object.assign({}, { ...rule, rhs: [0, 0] }, { operator: dropdown.value });
    }
    this.props.onRuleChange(newRule);
  }

  handleOnChange = (e: any, data: any) => {
    if (data.name === `${this.props.rule.uid}-input`) {
      const rhs = parseInt(e.target.value, 10);
      const newRule = { ...this.props.rule, rhs };
      this.props.onRuleChange(newRule);
    }
    if (data.name === `${this.props.rule.uid}-input-btLow`) {
      const rhsValue = parseInt(e.target.value, 10);
      const rhs = this.props.rule.rhs;
      rhs[0] = rhsValue;
      const newRule = { ...this.props.rule, rhs };
      this.props.onRuleChange(newRule);
    }
    if (data.name === `${this.props.rule.uid}-input-btHigh`) {
      const rhsValue = parseInt(e.target.value, 10);
      const rhs = this.props.rule.rhs;
      rhs[1] = rhsValue;
      const newRule = { ...this.props.rule, rhs };
      this.props.onRuleChange(newRule);
    }
  }
  render() {
    const { rule, ruleType, isSelected } = this.props;
    const isBetween = rule.operator === 'bt';
    return (
      <span>
        <span>{ruleType.noun}</span>
        <span className="horizontal-margin">
          <Dropdown
            inline
            options={operatorOptions(ruleType)}
            defaultValue={rule.operator}
            onChange={this.handleRuleOperatorSelect}
            disabled={!isSelected}
          />
        </span>
        {isBetween &&
          <div>
            <Form.Input
              name={`${rule.uid}-input-btLow`}
              value={this.props.rule.rhs[0]}
              onChange={(e, data) => this.handleOnChange(e, data)}
            />
            <Form.Input
              name={`${rule.uid}-input-btHigh`}
              value={this.props.rule.rhs[1]}
              onChange={(e, data) => this.handleOnChange(e, data)}
            />
          </div>
        }
        {!isBetween &&
          <Form.Input
            name={`${rule.uid}-input`}
            value={_.get(rule, 'rhs')}
            onChange={(e, data) => this.handleOnChange(e, data)}
          />
        }
      </span>
    );
  }
}
